'use strict';

var forEach = require('../../common/internal/forEach'),
    addPlural = require('./addPlural'),
    spaceSplit = require('../../common/internal/spaceSplit');

function addUncountable(set) {
  forEach(spaceSplit(set), function(str) {
    addPlural(str);
  });
}

module.exports = addUncountable;